export const NESTED_PAYMENT_EDIT_TYPES_WITH_SOURCE = [
  'APPLICATION_FEE',
  'CONTRACT',
  'CONTRACT_INVOICE',
  'APPLICATION_FEE_INVOICE',
]

export const NESTED_PAYMENT_EDIT_TYPES_WITHOUT_SOURCE = [
  'CONTRACT_CHARGEBACK',
  'CHGBACK_APP_FEE',
  'CHGBACK_CONTRACT',
  'CONTRACT_INVOICE',
  'APPLICATION_FEE_INVOICE',
  'BALANCE_ADJUSTMENT',
]

export const NESTED_PAYMENT_REJECTED_REFUND_TYPES = [
  'CONTRACT_REFUND_PARTIAL',
  'CONTRACT_REFUND_FULL',
]

export const NESTED_PAYMENT_DELETE_TYPES_WITHOUT_SOURCE = [
  'APPLICATION_FEE_INVOICE',
  'CONTRACT_INVOICE',
  'CONTRACT_CHARGEBACK',
  'CHGBACK_APP_FEE',
  'CHGBACK_CONTRACT',
]

export const NESTED_PAYMENT_DELETE_EXCLUDED_INCOMPLETE_TYPES = [
  'APPLICATION_FEE',
  'CONTRACT',
  'APPLICATION_FEE_INVOICE',
  'CONTRACT_INVOICE',
]

export const NESTED_PAYMENT_EXTERNAL_SOURCE_MARKER = 'EXTERNAL_PAYMENT'

export const NESTED_PAYMENT_STATUS_REJECTED = 'Rejected'
export const NESTED_PAYMENT_STATUS_CANCELLED = 'Cancelled'
export const NESTED_PAYMENT_STATUS_COMPLETED = 'Completed'

export const NESTED_PAYMENT_EDIT_POLICY = 'application_detail_payment_log_edit'
export const NESTED_PAYMENT_DELETE_POLICY = 'application_detail_payment_log_delete'
